var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 200.424,
    height: 200,
    rx: 100
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7F8",
    transform: "matrix(1 0 0 -1 0 200)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 71)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 143,
    r: 74,
    fill: "#D3D7DD"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 62,
    fill: "#DDE1E7",
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BBC1C9",
    transform: "translate(12.5 20.784)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.716,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 11.716,
    r: 11.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarRobot);
export default __webpack_public_path__ + "static/media/avatar-robot.5cf0906d70ddc1264f258ed3ff2729f0.svg";
export { ForwardRef as ReactComponent };